"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var BrowserDetection_1 = require("./BrowserDetection");
var id = Date.now(); // TFSID 872587 don't start from 0 because Chrome assumes same-id is same-field
function generateId() {
    return "tab-shared-widget-" + id++;
}
exports.generateId = generateId;
/** setTimeout around node.focus, with some safety checks */
function timeoutFocus(node) {
    window.setTimeout(function () {
        if (node && window.document.body.contains(node)) {
            node.focus();
        }
    });
}
exports.timeoutFocus = timeoutFocus;
function detectScrollbarWidth() {
    var div = document.createElement('div');
    div.className = 'scrollbarMeasurement';
    tslib_1.__assign(div.style, {
        width: '100px',
        height: '100px',
        overflowY: 'scroll',
        position: 'absolute',
        visibility: 'hidden',
        border: 'none'
    });
    document.body.appendChild(div);
    var scrollbarWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
    return scrollbarWidth;
}
exports.detectScrollbarWidth = detectScrollbarWidth;
function isElementOverflownX(element) {
    return element && element.clientWidth < element.scrollWidth;
}
exports.isElementOverflownX = isElementOverflownX;
function closest(element, selector) {
    if (element.closest) {
        return element.closest(selector);
    }
    var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    if (!matches) {
        return null;
    }
    var node = element;
    while (node) {
        if (matches.call(node, selector)) {
            return node;
        }
        node = node.parentElement;
    }
    return null;
}
exports.closest = closest;
/** n.b. in IE/Edge this method only inspects and adjusts vertical scrolling */
function scrollIntoView(elem, block) {
    if (block === void 0) { block = 'nearest'; }
    if (!elem) {
        return;
    }
    if (!(BrowserDetection_1.isIE || BrowserDetection_1.isEdge)) {
        elem.scrollIntoView({ block: block, behavior: 'auto' });
    }
    else {
        var scrollableParent = elem.parentElement;
        var overflowY = '';
        while (scrollableParent) {
            overflowY = getComputedStyle(scrollableParent).overflowY;
            if (overflowY === 'auto' || overflowY === 'scroll') {
                break;
            }
            scrollableParent = scrollableParent.parentElement;
        }
        if (scrollableParent) {
            var elemRect = elem.getBoundingClientRect();
            var scrollRect = scrollableParent.getBoundingClientRect();
            if (elemRect.bottom > scrollRect.bottom) {
                scrollableParent.scrollTop += elemRect.bottom - scrollRect.bottom;
            }
            else if (elemRect.top < scrollRect.top) {
                scrollableParent.scrollTop += elemRect.top - scrollRect.top;
            }
        }
    }
}
exports.scrollIntoView = scrollIntoView;
function findBlurRelatedTarget(e) {
    if (BrowserDetection_1.isIE) {
        // Blur doesn't have relatedTarget in IE11: https://github.com/facebook/react/issues/3751
        return (e.relatedTarget || document.activeElement);
    }
    else {
        return e.relatedTarget;
    }
}
exports.findBlurRelatedTarget = findBlurRelatedTarget;
// nasty hack to work around Safari bug which dispatches multiple focus events with
// as single click on trackpads: https://github.com/facebook/react/issues/10871
// credit to https://gist.github.com/pmacmillan/5e78836821ac22031567382dadd4a72e
function shouldIgnoreFocusEvent(e) {
    // tslint:disable:no-any
    var target = e.target;
    // tslint:disable:no-any
    var relatedTarget = e.relatedTarget;
    // test if we are ignoring the current event because we recevied another one too soon
    if (target.lastFocusEventMs && e.timeStamp < target.lastFocusEventMs + 100) {
        return true;
    }
    target.lastFocusEventMs = e.timeStamp;
    if (relatedTarget) {
        relatedTarget.lastFocusEventMs = e.timeStamp;
    }
    return false;
}
exports.shouldIgnoreFocusEvent = shouldIgnoreFocusEvent;
//# sourceMappingURL=DomUtil.js.map